import React from 'react';

import { Grid, Typography } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import computerLady1 from '../assets/computerladyDellLogoRemoved.jpg';
import computerLady1M from '../assets/computerladyDellLogoRemovedM.jpg';

import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    marginTop: '6.5rem',
    [theme.breakpoints.down('sm')]: {
      marginTop: '2.5rem'
    }
  },
  row1: {
    width: '100%'
  },
  halfPhoto: {
    width: '50%',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  caption: {
    marginTop: '5px',
    textAlign: 'center'
  }
}));

const PhotoCollage1 = () => {
  const classes = useStyles();
  const theme = useTheme();
  const matchesSM = useMediaQuery(theme.breakpoints.down('sm'));
  const { ref, inView } = useInView({ triggerOnce: true });

  const renderer = (
    <>
      <Grid container className={classes.row1}>
        <motion.img
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 2, delay: 0.4 } }}
          src={matchesSM ? computerLady1M : computerLady1}
          alt="lady on computer"
          style={{ width: '100%' }}
        />
      </Grid>
      <Grid item className={classes.caption}>
        <Typography variant="caption">
          During the COVID-19 pandemic, Nikki works from home in Duluth, Minnesota
        </Typography>
      </Grid>
    </>
  );

  return (
    <Grid ref={ref} container direction="column" className={classes.wrapper}>
      {inView ? renderer : null}
    </Grid>
  );
};

export default PhotoCollage1;
